import P2Regular from 'components/typography/P2Regular';
import { FaultRow } from 'components/tables/data/fault/types';

/**
 * Column for the safety conclusion of the linked revision or form.
 */
export default function RevisionSafetyPointColumn({ data: { safetyPointPretty } }: { data: FaultRow }) {
  return <P2Regular lineClamp={3}>{safetyPointPretty}</P2Regular>;
}
